import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'
import Checkbox from '../../form/Checkbox'
import Typography from '../../../UniformComponents/Typography'

const OptOutLinkWarningModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.optOutLinkWarningModalVisible}
        onClose={distributeStore.hideOptOutLinkWarningModal}
    >
        <Typography type="h2">
            {i18n.t('distributionOptOutLinkModal.title')}
        </Typography>

        <br />

        <br />

        <div className="opt-out-modal-information">
            <Typography>{i18n.t('distributionOptOutLinkModal.content')}</Typography>

            <br />

            <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                <Typography type="b">{i18n.t('distributionOptOutLinkModal.checkbox')}</Typography>

                <Checkbox
                    onBlur={distributeStore.toggleOptOutModalCheckbox}
                />
            </div>
        </div>

        <br />

        <hr />

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
                cssClass="regular tertiary"
                onClick={distributeStore.hideOptOutLinkWarningModal}
                label={i18n.t('back')}
            />

            <Button
                cssClass="regular primary"
                onClick={distributeStore.optOutModalContinue}
                disabled={!distributeStore.optOutChecked}
                label={i18n.t('next')}
            />
        </div>
    </Modal>
)

export default observer(OptOutLinkWarningModal)
